import { Component, OnInit, OnDestroy } from '@angular/core';
import { CodeValueConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeValueConversionMst.service';
import { ActivatedRoute } from '@angular/router';
import { Sgkb575aRequest, CodeValueConversionMstDto, Sgkb575aResCommonAceptSearchResultDto } from 'sg-api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UsedSgkb106dSgkb575aService } from '../../services/used-sgkb106d-sgkb575a.service';

@Component({
  selector: 'app-sgkb106d-important-matter',
  templateUrl: './sgkb106d-important-matter.component.html',
  styleUrl: './sgkb106d-important-matter.component.scss'
})
export class Sgkb106dImportantMatterComponent implements OnInit, OnDestroy {
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** 非表示項目：会社コード */
  companycode: string;
  /** 非表示項目：受付番号 */
  aceptNo: string;
  /** 非表示項目：業種 */
  gyoshu: string;
  /** 非表示項目：ログイン情報 */
  loginInfo: string;

  /** コード値変換マスタマップ */
  private codeValueConversionMstMap: Map<string, Array<CodeValueConversionMstDto>>;
  /** 共通受付照会結果リスト */
  private commonAceptSearchResultList: Array<Sgkb575aResCommonAceptSearchResultDto>;
  /** コード値変換識別種別:共通重要事項URLキー */
  private discrmClsCodeSgkb012: string = 'SGKB012';
  /** 重要事項説明 共通事項URL */
  public importantItemUrl: string;

  constructor(
    private route: ActivatedRoute,
    private codeValueConversionMstService: CodeValueConversionMstService,
    private usedSgkb106dSgkb575aService: UsedSgkb106dSgkb575aService,
  ) {
    // 画面間パラメータ取得
    this.aceptNo = this.route.snapshot.paramMap.get('aceptNo');
    this.gyoshu = this.route.snapshot.paramMap.get('gyoshu');
    this.loginInfo = this.route.snapshot.paramMap.get('loginInfo');
  }

  /**
   * 初期処理
   * @memberof Sgkb106dImportantMatterComponent
   */
  ngOnInit(): void {

    // コード値変換マスタマップ取得
    this.codeValueConversionMstService.getCodeValueConversionMst([
      this.discrmClsCodeSgkb012
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.codeValueConversionMstMap = data;
      });

    // 共通受付照会リクエスト設定
    const sgkb575aRequest: Sgkb575aRequest = {
      aceptSearchInfo: {
        // 受付番号
        aceptNo: null,
        // 導管事業者申請受付番号
        doknjgyshAppAcceptancenumber: this.aceptNo,
        // 受付履歴表示フラグ
        acceptancerirekiHyojiFlg: false,
      }
    };

    // 共通受付照会レスポンス取得
    this.usedSgkb106dSgkb575aService.searchContractor(sgkb575aRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.commonAceptSearchResultList = response.commonAceptSearchResultList;

        // 共通受付照会レスポンスから会社コードを取得
        this.companycode = this.commonAceptSearchResultList[0].aceptCommonInfo.companycode;
        // コード値変換マスタマップから共通重要事項URLキーに紐づくコード値変換マスタDtoリストを取得
        let codeValueConversionMstDtoList = this.codeValueConversionMstMap.get(this.discrmClsCodeSgkb012);
        // コード値変換マスタDtoリストから事前に取得した会社コード、業種の1桁目に一致するコード値変換マスタDtoを取得
        let codeValueDto = codeValueConversionMstDtoList.find((codeValue) =>
          codeValue.cnversOriginCode1 === this.companycode && codeValue.cnversOriginCode2 === this.gyoshu.substring(0, 1));
        // コード値変換マスタDtoから変換後１テキスト（＝重要事項説明 共通事項URL）を取得
        this.importantItemUrl = codeValueDto.cnversAfterText1;
      });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
